import React, { useEffect, useRef, useState } from 'react';
import { useInView, useReducedMotion } from 'framer-motion';
import AICircle from '@components/AICircle';
import './styles.scss';

export default function StudioAi({ size = 28, active = true }) {
  const orb = useRef(null);
  const container = useRef(null);
  const visible = useInView(container);
  const [foreground, setForeground] = useState(() => !document.hidden);
  const reduced = useReducedMotion();
  useEffect(() => {
    const update = () => setForeground(!document.hidden);
    document.addEventListener('visibilitychange', update);
    return () => document.removeEventListener('visibilitychange', update);
  }, []);
  useEffect(() => { orb.current?.setActive(active && visible && foreground && !reduced); }, [active, visible, foreground, reduced]);
  return <span ref={container} className="studio-ai" aria-hidden="true"><AICircle ref={orb} size={size} active={false} /></span>;
}
